import { BaseComponent } from '../base-component'

const INTERSECTION_OBSERVER_OPTIONS = {}

export class LazyVideo extends BaseComponent {
  intersectionObserver: IntersectionObserver

  mountComponent(): void {
    this.intersectionObserver = new IntersectionObserver(
      this.handleIntersectionObserve,
      INTERSECTION_OBSERVER_OPTIONS,
    )
    this.intersectionObserver.observe(this)
  }

  unmountComponent(): void {
    this.intersectionObserver.disconnect()
  }

  handleIntersectionObserve = (entries: IntersectionObserverEntry[]): void => {
    if (!entries[0].isIntersecting) {
      return
    }

    this.intersectionObserver.unobserve(this)
    this.intersectionObserver.disconnect()

    this.initVideo()
  }

  initVideo = () => {
    const parentNode = this.parentNode
    const withAutoplay = this.hasAttribute('with-autoplay')

    if (!parentNode) {
      return
    }

    const video = this.querySelector('video') as HTMLVideoElement
    video.load()

    const handleTouch = () => {
      if (video.paused && withAutoplay) {
        video.load()
        video.play()
      }

      this.removeListener(window, 'touchstart', handleTouch)
    }

    const handleCanPlay = () => {
      parentNode.replaceChild(video, this)

      if (withAutoplay) {
        video.play()
      }

      this.removeListener(video, 'canplaythrough', handleCanPlay)
    }

    this.addListener(video, 'canplaythrough', handleCanPlay)
    this.addListener(window, 'touchstart', handleTouch)
  }
}
